import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApplicantTemplate } from 'src/app/models/applicant-template.model';
import { TemplateModel } from 'src/app/models/template-model.model';
import { IFilterTemplateQuestions, TemplateQuestions } from 'src/app/models/template-questions.model';
import { TemplateResult } from 'src/app/models/template-result.model';
import { Theme } from 'src/app/models/theme-model';
import { ITemplateFilter, Template  } from '../../models/template.model';
import { HttpCERS } from '../cers.api';


@Injectable({
    providedIn: 'root'
})
export class TemplateService {

    constructor(private api: HttpCERS) {
        this.api = api.setContext('/template');
        this.api.setLocalContext('', 'http://localhost:8244');
    }

    findAll(isEnabled: boolean = false): Observable<Template[]> {
      return isEnabled ? this.api.get('/?is_enabled=true') : this.api.get('/');
    }

    findAllPaginate(isEnabled: boolean = false, page: number = 1, size: number = 20): Observable<TemplateResult> {
      return this.api.get(`/paginate?is_enabled=${isEnabled}&page=${page}&size=${size}`);
    }


    findById(templateId: number): Observable<Template> {
      return this.api.get('/find/' + templateId.toString());
    }

    searchTemplate(filter: ITemplateFilter,isEnabled: boolean = false, page: number = 1, size: number = 20): Observable<TemplateResult> {
      return this.api.get(`/search?is_enabled=${isEnabled}&page=${page}&size=${size}` , filter);
    }

    findQuestions(modelId: number): Observable<TemplateModel> {
      return this.api.get(`/model/${modelId.toString()}/questions`);
    }

    findQuestionsWithTeacher(modelId: any): Observable<TemplateModel> {
      return this.api.get(`/model/${modelId.toString()}/questionsWithTeacher`);
    }

    findQuestionsOther(modelId: any): any {
      return this.api.get(`/model/${modelId.toString()}/otherModels`);
    }

    create(template: Template) {
      const body = JSON.stringify(template);
      return this.api.post('/', body);
    }

    update(template: Template) {
      return this.api.put('/', template);
    }

    findModels(templateId: number): Observable<TemplateModel[]> {
      return this.api.get('/' + templateId.toString() + '/models');
    }

    findApplicantTemplate(applicantId: number, templateId: number) {
      return this.api.get('/applicant/verify', {applicantId, templateId});
    }

    createApplicantTemplate(applicantTemplate: ApplicantTemplate) {
      return this.api.post('/applicant', applicantTemplate);
    }

    updateApplicantTemplate(applicantTemplate: ApplicantTemplate) {
      return this.api.put('/applicant', applicantTemplate);
    }

    createApplicantAnswers(applicantAnswers) {
      return this.api.post('/applicant/answers', applicantAnswers);
    }

    findDisciplines(templateId: number) {
      return this.api.get('/' + templateId.toString() + '/disciplines');
    }

    findThemes(filter: string): Observable<Theme> {
      return this.api.get('/themes/filter', {filter})
      .pipe(
             tap((response: Theme[]) => {
              response = response
              .map(theme => new Theme({ id: theme.id, title: theme.title, createdAt: theme.createdAt }));
              return response;
             })
      );
    }

    updateTemplateQuestions(questions: TemplateQuestions) {
      return this.api.put('/questions', questions);
    }

    filterQuestions(filter: IFilterTemplateQuestions) {
      return this.api.get('/questions/search', filter);
    }

    verifyVideoQuestion(templateQuestionsId: number) {
      return this.api.get('/questions/' + templateQuestionsId.toString() + '/verify-video');
    }

    associate(templateQuestions: TemplateQuestions) {
      return this.api.put('/questions/associate', templateQuestions);
    }

    setOfficialAnswers(officialAnswers) {
      return this.api.post('/questions/official-answers', officialAnswers);
    }

    uploadQuestion(file: File, questionId) {
      return this.api.postFile(`/questions/${questionId}/upload-image`, file);
    }

    findQuestionsById(questionId) {
      return this.api.get(`/questions/${questionId}`);
    }

    getVideotecaToken(questionId, applicant) {
      return this.api.post(`/questions/${questionId}/videoteca-token`, applicant);
    }

  }
